class Form {
  constructor(formFields) {
    this.fields = formFields;
    this.sectionedField = this.sortbySection(formFields);
  }

  sortbySection(fields) {
    return fields.reduce((result, field) => {
      if (field.section) {
        if (result[field.section]) result[field.section].push(field);
        else result[field.section] = [field];
        return result;
      }
      if (result["No section"]) result["No section"].push(field);
      else result["No section"] = [field];

      return result;
    }, {});
  }

  getFormData() {
    return this.sectionedField;
  }

  getProjection() {
    return this.fields.reduce((obj, field) => {
      obj[field.id] = 1;
      return obj;
    }, {});
  }
}
export default Form;
